// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"61e81d9c","174":"6af7e3bb","234":"7bcbe084","253":"76d7810d","397":"5bfbbfe6","406":"c0c75a13","437":"37076489","837":"dcabefa0"}[chunkId] + ".chunk.css";
};